module.exports = __webpack_public_path__ + "img/__icon_WALKINGFLOOR .21373ea0.svg";